export const AUTH = {
  LOGIN: '/login'
};

export const HOME = {
  HOME: '/'
};

export const HOMEWORK_MANAGEMENT = {
  HOMEWORKS: '/homeworks',
  PREVIEW: '/homeworks/preview',
  HOMEWORK_DETAILS: '/homeworks/:id/:assignmentId/:classID',
  REPORTS: '/homeworks/reports/:assignmentId/:classId'
};

export const DASHBOARD = {
  DASHBOARD: '/dashboard',
  NEW_DASHBOARD: '/new-dashboard'
};

export const CHAT = {
  CHAT: '/chat'
};

export const NOTICEBOARD = {
  NOTICEBOARD: '/noticeboard'
};

export const CLASSES = {
  CLASSES: '/classes',
  CLASS: '/classes/:id',
  REPORTS: '/classes/reports/:id'
};

export const STUDENTS = {
  STUDENTS: '/students',
  STUDENT: '/students/:id',
  STUDENT_HOMEWORK_DETAILS: '/students/homeworks/:studentId/:assignmentId',
  STUDENT_REPORTS: '/students/reports/:id/:classId'
};

export const NOTIFICATIONS = {
  NOTIFICATIONS: '/notifications'
};

export const SETTINGS = {
  SETTINGS: '/settings'
};

export const ERROR = {
  ERROR: '/error/:errorStatus'
};

export const CALENDAR = {
  CALENDAR: '/calendar'
};
